module dg.objects {

    export class DatepickerPopupController {

        public constructor(
            private $scope: ng.IScope,
            private $timeout: ng.ITimeoutService,
            private dateService: DateService
        ) { }

        public ngModel: ng.INgModelController;
        public propMeta: restfulApi.DomainObjectPropertyMetadata;
        public domainObjectCtrl: ObjectEditorController
        public date: any;
        public valueObj: any;
        public status = {
            datepickerOpened: false
        };
        public timePickerOptions = {
            showMeridian: false
        }

        public openDatepicker = ($event) => {
            this.$timeout(() => {
                this.status.datepickerOpened = true;
            });
        };

        $onInit() {
            if (this.propMeta["UTC"]) {
                this.valueObj = this.dateService.dateTimeToUTC(this.valueObj);
                this.valueChanged();
            }
        }

        $onChanges(changes) {
            if (changes.date.currentValue) {
                this.valueObj = changes.date.currentValue;
            }
        }


        public valueChanged() {
            this.ngModel.$setViewValue(this.valueObj);
        }

        public updateViewValue = (error) => {

            //this.ngModel.$setViewValue(this.date);
            //var currError = this.ngModel.$error;

            //var finalError = _.assignInWith(error, currError, (objVal, sourceVal) => {
            //    return angular.isDefined(objVal);
            //});
            //angular.forEach(finalError, (value, key) => {
            //    this.ngModel.$setValidity(key, !value);
            //});
            //this.ngModel.$setDirty();
        }
    }

    angular.module('dg.objects').component('datepickerPopup', {
        bindings: {
            date: '<ngModel',
            propMeta: '<',
        },
        require: {
            ngModel: 'ngModel',
            domainObjectCtrl: '^objectEditor'
        },
        controller: DatepickerPopupController,
        templateUrl: '/digmo/src/objects/properties/date/datepicker-popup.html'
    });

    angular.module('dg.objects')

        .directive('datepickerModel', () => {
            return {
                restrict: 'A',
                require: ['ngModel', '^datepickerPopup'],
                link: (scope, element, attr, controllers) => {
                    var ngModel = controllers[0];
                    var datepickerPopup: DatepickerPopupController = controllers[1];
                    ngModel.$viewChangeListeners.push(() => {
                        datepickerPopup.updateViewValue(ngModel.$error);
                    });
                }
            }
        });
}